import * as Yup from 'yup';

import { EventCheckout } from 'store/api/event';

import { ReturnPayment } from './types';

const toNum = (val: any) => Number(val) || 0;

export const validateReturnPayments = (
  returnPayments: ReturnPayment[],
  context: Yup.TestContext<Yup.AnyObject>,
  data?: EventCheckout
) => {
  const availableCash = toNum(data?.availableForRefund?.cash);
  const availableCredit = toNum(data?.availableForRefund?.credit);
  const refundedByCloverCards = data?.refundedByCloverCards || [];

  const { totalCash, cardTotals, totalCredit } =
    calculateReturnPaymentTotals(returnPayments);

  if (totalCash > availableCash) {
    return context.createError({
      message: `You cannot refund more than $${availableCash.toFixed(2)} in cash`,
    });
  }

  if (totalCredit > availableCredit) {
    return context.createError({
      message: `You cannot refund more than $${availableCredit.toFixed(2)} in credit`,
    });
  }

  for (const [paymentId, totals] of Object.entries(cardTotals)) {
    const card = refundedByCloverCards.find((c) => c.paymentId === paymentId);

    if (!card) {
      return context.createError({
        message: `Card with payment ID ${paymentId} not found`,
      });
    }

    if (totals.amount > card.availableForRefund) {
      return context.createError({
        message: `You cannot refund more than $${card.availableForRefund.toFixed(2)} to card ending in ${card.last4}`,
      });
    }

    if (totals.fee > card.availableFeeRefund) {
      return context.createError({
        message: `You cannot refund more than $${card.availableFeeRefund.toFixed(2)} in processing fees for card ending in ${card.last4}`,
      });
    }
  }

  return true;
};

const calculateReturnPaymentTotals = (returnPayments: ReturnPayment[]) => {
  const toNum = (val: any) => Number(val) || 0;

  const result = returnPayments.reduce(
    (acc, payment) => {
      if (payment.type === 'cash') {
        acc.totalCash += toNum(payment.amount);
      }

      if (payment.type === 'credit') {
        acc.totalCredit += toNum(payment.amount);

        if (payment.cloverPaymentId) {
          if (!acc.cardTotals[payment.cloverPaymentId]) {
            acc.cardTotals[payment.cloverPaymentId] = { fee: 0, amount: 0 };
          }
          acc.cardTotals[payment.cloverPaymentId].amount += toNum(
            payment.amount
          );
          acc.cardTotals[payment.cloverPaymentId].fee += toNum(
            payment.processingFee
          );
        }
      }

      return acc;
    },
    {
      totalCash: 0,
      totalCredit: 0,
      cardTotals: {} as Record<string, { fee: number; amount: number }>,
    }
  );

  result.totalCash = Math.round(result.totalCash * 100) / 100;
  result.totalCredit = Math.round(result.totalCredit * 100) / 100;

  for (const key in result.cardTotals) {
    result.cardTotals[key].amount =
      Math.round(result.cardTotals[key].amount * 100) / 100;
    result.cardTotals[key].fee =
      Math.round(result.cardTotals[key].fee * 100) / 100;
  }

  return result;
};
